import { IBaseResponse } from './../interface/IBaseResponse';
import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IChangeExpenseStatusRequest } from '../interface/Expense/IChangeExpenseStatusRequest';

enum ExpenseRequestServiceEnum {
	getReason = '/get-reason/',
	putRejectedStatus = '/reject',
	putApproveStatus = '/approve',
	putReviewStatus = '/return',
	postRedoOcr = '/redo-ocr-expense?expenseId='
}

export class ExpenseRequestService extends ApiService {
	public reason = {
		get: async (expenseId: number): Promise<IBaseResponse> => await this.GET(ExpenseRequestServiceEnum.getReason + expenseId)
	};

	public putStatus = {
		reject: async (data: IChangeExpenseStatusRequest): Promise<IBaseResponse> => await this.PUT(ExpenseRequestServiceEnum.putRejectedStatus, data),
		approve: async (data: IChangeExpenseStatusRequest): Promise<IBaseResponse> => await this.PUT(ExpenseRequestServiceEnum.putApproveStatus, data),
		review: async (data: IChangeExpenseStatusRequest): Promise<IBaseResponse> => await this.PUT(ExpenseRequestServiceEnum.putReviewStatus, data)
	};

	public ocr = {
		redo: async (expenseId: number): Promise<void> => await this.POST(ExpenseRequestServiceEnum.postRedoOcr + expenseId)
	};


	constructor(restClient: AxiosInstance) {
		super(restClient, '/expense');
	}
}
